module.exports = __webpack_public_path__ + "./assets/img_ntu_grey@2x__f0a6979be8c87beace45103e96446004.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/img_ntu_grey@2x.jpg
// module id = 622
// module chunks = 12